(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    


$('.announcement-bar').slick({
infinite: true,
slidesToShow: 1,
slidesToScroll: 1,
autoplay: true,
arrows: false,
pauseOnFocus: false,
pauseOnHover: false,
speed: 8000,
autoplaySpeed: 0,
cssEase: 'linear',
variableWidth: true
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-image"] && !Shopify.designMode) return;
  try {
    
	$('.featured-image--section').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      autoplaySpeed: 4000,
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-brands"] && !Shopify.designMode) return;
  try {
    
	$('.home-brands__items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 8000,
      autoplaySpeed: 0,
      cssEase: 'linear',
      variableWidth: true
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["items-slider"] && !Shopify.designMode) return;
  try {
    

	$('.all-slider-items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
	  prevArrow: '.items-slider--arr-prev',
	  nextArrow: '.items-slider--arr-next',
	  responsive: [
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 1,
			dots: true,
			appendDots: '.low-size-nav'
          }
        }
	  ]
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ba-guidebook"]) return;
  try {
    
	document.body.classList.add("ba-gdlines-page");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
var buttons = document.querySelectorAll('.js-accordion-items button[aria-controls]');

buttons.forEach(button => {
	button.addEventListener('click', function(){
		var id = button.dataset.buttonId;
		var $content = document.querySelector('[data-content-id="' + id + '"]');	
		
		if ($content.classList.contains('show')) {
			$content.classList.remove('show');
			button.classList.remove('active');
			$content.setAttribute('aria-hidden', 'true');
		} else {
			$content.classList.add('show');
			button.classList.add('active');
			$content.setAttribute('aria-hidden', 'false');
		}
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-why-gonanas"]) return;
  try {
    
	document.body.classList.add("why-gonanas-page");


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	function resizeImageWrappers() {
      setTimeout(function() {
          var windowWidth = window.innerWidth
          if ($('.product-rec--spread .product--wrapper')) {
            $('.product-rec--spread .product--wrapper').each(function() {
                $(this).height(windowWidth / 2 + 'px')
            });
          }

      }, 1000);
	}

	// resizeImageWrappers();

	// $(window).on('resize', resizeImageWrappers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  $('.product-single__meta select.to-be-styled').each(function () {
    var $this = $(this),
        numberOfOptions = $(this).children('option').length;

    $this.addClass('s-hidden');

    $this.wrap('<div class="select"></div>');

    $this.after('<div class="styledSelect"></div>');

    var $styledSelect = $this.next('div.styledSelect');

    $styledSelect.text($this.children('option').eq(0).text());

    var $list = $('<ul />', {
      'class': 'options'
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
      $('<li />', {
        text: $this.children('option').eq(i).text(),
        rel: $this.children('option').eq(i).val()
      }).appendTo($list);
    }

    var $listItems = $list.children('li');

    $styledSelect.click(function (e) {
      e.stopPropagation();
      if($(this).hasClass('active')) {
      	$(this).next('ul.options').hide();
      }
      else {
      	$(this).next('ul.options').show();
      }

      $(this).toggleClass('active');
    });
                                        
    $listItems.click(function (e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $this.val($(this).attr('rel'));
      $list.hide();
      var selectedFlavor = $('#products_selection').find(":selected").val();
      if(selectedFlavor != window.location.pathname){
         // window.location.replace(selectedFlavor);
		window.location.href = selectedFlavor;
	  }
	  
	  
  	});
  
    jQuery(document).mouseup(function (e){
      var container = jQuery(".styledSelect");
      if (!container.is(e.target) && container.has(e.target).length === 0){
        $('.styledSelect').removeClass('active');
        $list.hide();
      }
    });
                                        
	jQuery('#rc_autodeliver_options ul.options li').click(function (e) {
    	e.stopPropagation();
    	jQuery(this).prependTo('#rc_autodeliver_options ul.options');
  	});
                                        
});      
                                        
// window.SLIDECART_ADD_TO_CART = function({ id, quantity }) {
//     // Fires whenever an item has been added to cart
//     console.log('id', id);
//     console.log('quantity', quantity);
    

//     if ($('textarea[name="properties[note]"]').length > 0) {
//         window.SLIDECART_UPDATE(function(cart){
//             console.log('cart', cart);
//             let currCart = cart;
//             let updatedItems = currCart.items.filter(function(item) {
//                 if (item.variant_id === id) {
//                     item.properties.note = $('textarea[name="properties[note]"]').val();
//                 }
//                 return true;
//             });
//             console.log('updatedItems', updatedItems);
//             currCart.items = updatedItems;
//             console.log('currCart', currCart);
//             window.SLIDECART_SET_CART(currCart);
//         });
//     }
// }

 

                                        

  } catch(e) { console.error(e); }
})();
})();
